import { css } from "@compiled/react";

import { ExistingUser } from "@/components/signup/site-activation";
import { useSiteActivationContext } from "@/components/signup/site-activation/hooks/site-activation-context";

import { FormWithPaymentOverlay, PrivacyPolicy, WelcomeBackHeading } from "..";

import { AddPaymentMethodContent } from "./add-payment-method-content";
import { PaymentDetailsContent } from "./existing-sites-user-payment";

export const ExistingUserWithPaymentSwitcher = () => {
    const { paymentDetailsView } = useSiteActivationContext();

    const overlayContent =
        paymentDetailsView.view === "payment-required" ? (
            <AddPaymentMethodContent />
        ) : paymentDetailsView.view === "payment" ? (
            <PaymentDetailsContent />
        ) : undefined;

    return (
        <>
            {paymentDetailsView.view === "standard" && (
                <h1 css={headerCss}>
                    <WelcomeBackHeading />
                </h1>
            )}
            <FormWithPaymentOverlay
                paymentDetailsPage={overlayContent}
                fullViewportOverlay={
                    paymentDetailsView.view === "payment-required"
                }
            >
                <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
            </FormWithPaymentOverlay>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
